export const SETTING = {
  ROOT: '/setting',
  APARTMENTS: '/setting/apartments',
  ENG_NET: '/setting/engineering',
  ENG_NET_BY_PROJECT: '/setting/engineering/byProject',
  ENG_NET_BY_OBJECT: '/setting/engineering/byObject',
};
